import React from 'react';

// 토글 버튼 props 인터페이스
interface ToggleButtonsProps {
  options: string[];              // 토글 옵션들 (예: ['학급운영', '교과운영'])
  selectedIndex: number;          // 현재 선택된 옵션의 인덱스
  onToggle: (index: number) => void; // 토글 변경 시 호출되는 함수
  className?: string;             // 추가 CSS 클래스
}

// ToggleButtons 컴포넌트 정의
const ToggleButtons: React.FC<ToggleButtonsProps> = ({ 
  options,           // 토글 옵션들
  selectedIndex,     // 현재 선택된 인덱스
  onToggle,          // 토글 변경 함수
  className = '' 
}) => {
  return (
    <div 
      style={{
        // Figma에서 가져온 컨테이너 스타일
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 4,                    // Figma에서 가져온 간격
        display: 'flex'
      }}
      className={className}
    >
      {options.map((option, index) => {
        const isSelected = index === selectedIndex;
        
        return (
          <div 
            key={option}
            style={{
              // Figma에서 가져온 버튼 스타일
              height: 34,                              // Figma에서 가져온 높이
              paddingLeft: 16,                         // Figma에서 가져온 좌측 패딩
              paddingRight: 16,                        // Figma에서 가져온 우측 패딩
              background: isSelected 
                ? 'var(--Color-fill-brand-color, #FF6F0F)'  // 선택됨: 오렌지색
                : 'transparent',                            // 선택 안됨: 투명
              borderRadius: 999,                            // Figma에서 가져온 둥근 모서리
              justifyContent: 'center',            // 가로 중앙 정렬
              alignItems: 'center',                // 세로 중앙 정렬
              gap: 10,                                      // Figma에서 가져온 간격
              display: 'flex',                     // flexbox 레이아웃
              cursor: 'pointer',                            // 마우스 커서 변경, 일단 내맘대로
              transition: 'all 0.2s ease'                   // 부드러운 전환 효과, 일단 내맘대로
            }}
            onClick={() => onToggle(index)}                  // 클릭 시 토글 함수 호출
          >
            <div style={{
              // Figma에서 가져온 텍스트 스타일
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'column',
              color: isSelected 
                ? 'var(--Color-text-inverse, white)'        // 선택됨: 흰색
                : 'var(--Color-text-normal, #161616)',      // 선택 안됨: 검은색
              fontSize: 14,                                 // Figma에서 가져온 폰트 크기
              fontFamily: 'pretendard',                      // Figma에서 사용하는 폰트
              fontWeight: '500',                             // Figma에서 가져온 폰트 굵기
              lineHeight: isSelected ? '21px' : '14px',             // Figma에서 가져온 줄 간격
              wordWrap: 'break-word'               // 긴 텍스트 줄바꿈
            }}>
              {option}
            </div>
          </div>
        );
      })}
    </div>
  );

};

// ToggleButtons 컴포넌트를 다른 파일에서 사용할 수 있도록 내보내기
export default ToggleButtons;
